// assets/composables/useToast.js
// Module-level singleton state — shared across all component instances
import { ref } from 'vue'

const toasts = ref([])
let nextId = 0

export function useToast() {
    const addToast = (message, type = 'info', duration = 4000) => {
        const id = ++nextId
        toasts.value.push({ id, message, type })
        if (duration > 0) {
            setTimeout(() => removeToast(id), duration)
        }
        return id
    }

    const removeToast = (id) => {
        toasts.value = toasts.value.filter(t => t.id !== id)
    }

    return {
        toasts,
        addToast,
        removeToast,
        success: (msg) => addToast(msg, 'success'),
        error:   (msg) => addToast(msg, 'error', 6000),
        info:    (msg) => addToast(msg, 'info'),
        warning: (msg) => addToast(msg, 'warning'),
    }
}
